import { Controller } from 'stimulus';

/* Blocks file attachments (like pasted images) in Trix editors.
   Usage: Add data-controller="trix-no-attachments" to a trix-editor element. */

export default class TrixNoAttachmentsController extends Controller {
  connect() {
    this.element.addEventListener('trix-file-accept', this.preventFileAttachment);
  }

  disconnect() {
    this.element.removeEventListener('trix-file-accept', this.preventFileAttachment);
  }

  preventFileAttachment(event) {
    event.preventDefault();
  }
}
